import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Wraps a product page block whose markup depends on the selected variant.
 * When the variant changes, swaps its content for the matching block in the
 * section HTML the variant picker already fetched (matched by data-block-id).
 */
class GardenosVariantRegion extends Component {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /** @param {Event & { promise?: Promise<{ detail?: { html?: Document } }> }} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;

        const updated = html.querySelector(`gardenos-variant-region[data-block-id="${this.dataset.blockId}"]`);
        if (updated) this.replaceChildren(...Array.from(updated.childNodes, (node) => node.cloneNode(true)));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[gardenos-variant-region] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('gardenos-variant-region')) {
  customElements.define('gardenos-variant-region', GardenosVariantRegion);
}
